import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import { connect } from 'react-redux';

import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';

import { history } from '../../../_helpers';
import { projectActions } from '../../../_actions';

class DataTableContainer extends Component {
    componentDidMount() {
        this.props.dispatch(projectActions.getAll());
    }

    render() {
        const { projects } = this.props;

        const columns = [
            {
                name: "Action",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <IconButton color="secondary" aria-label="Edit" onClick={event => history.push('/Project/' + value)}>
                                <SearchIcon />
                            </IconButton>
                        );
                    },
                }
            },
            {
                name: "Project ID",
                options: {
                    filter: true,
                    sort: true,
                    sortDirection: 'desc',
                    filterType: 'multiselect',
                }
            },
            "Project Name",
            {
                name: "Tag",
                options: {
                    download: true,
                    filter: true,
                    filterType: 'multiselect',
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let tagData = Array.isArray(tableMeta.rowData[2]) ? tableMeta.rowData[2] : [];
                        return (
                            tagData ? tagData.map((item, index) => {
                                return (
                                    <div key={index}
                                        style={{
                                            border: '1px solid #ed3b57',
                                            width: 'fit-content',
                                            borderRadius: '10px',
                                            fontSize: '1em',
                                            color: '#ed3b57',
                                            padding: '0 10px',
                                            marginRight: '2px'
                                        }}>
                                        # {item}
                                    </div>
                                )
                            }) : ''
                        );
                    },
                }
            },
            "Project Team",
            {
                name: "Progress",
                options: {
                    download: true,
                    filter: true,
                    filterType: 'multiselect',
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                {value === '1' ? <abbr title="Pending"><div style={{ width: '10px', height: '10px', borderRadius: '99em', backgroundColor: 'red', marginRight: '10px' }} /></abbr> : null}
                                {value === '2' ? <abbr title="In-progress"><div style={{ width: '10px', height: '10px', borderRadius: '99em', backgroundColor: 'yellow', marginRight: '10px' }} /></abbr> : null}
                                {value === '3' ? <abbr title="Completed"><div style={{ width: '10px', height: '10px', borderRadius: '99em', backgroundColor: 'green', marginRight: '10px' }} /></abbr> : null}
                                {value === '4' ? <abbr title="Cancelled"><div style={{ width: '10px', height: '10px', borderRadius: '99em', backgroundColor: 'grey', marginRight: '10px' }} /></abbr> : null}
                                {value === '1' ? 'Pending' : ''}
                                {value === '2' ? 'In-Progress' : ''}
                                {value === '3' ? 'Completed' : ''}
                                {value === '4' ? 'Archived' : ''}
                            </div>
                        );
                    },
                }
            },
            {
                name: "Project Create Time",
                options: {
                    download: true,
                    filter: true,
                    filterType: 'multiselect',
                }
            },
            {
                name: "Percent Completed",
                options: {
                    download: true,
                    filter: true,
                    filterType: 'multiselect',
                }
            },
            {
                name: "Man-Day Achieving Rate",
                options: {
                    download: true,
                    filter: true,
                    filterType: 'multiselect',
                }
            },
        ];

        let data = projects.items && projects.items.map(item => {
            return [
                item.ProjectId,
                item.ProjectId,
                item.CompanyName + ' - ' + item.ProjectName,
                item.Tag ? item.Tag.map(item => {
                    return item.value ? item.value : ''
                }) : '',
                item.DepartmentName,
                item.ProgressStatus,
                item.CreatedTime ? convertDate(item.CreatedTime) : '',
                (item.CompletedPerent !== null ? Number(item.CompletedPerent) : 0) + ' %',
                Number(((item.Duration / 8) / item.Manday * 100).toFixed(0)) + ' %'
            ]
        })

        const options = {
            filter: true,
            selectableRows: false,
            filterType: "dropdown",
            responsive: "stacked",
            rowsPerPage: 10,
        };

        return (
            <MUIDataTable
                title={"Projects"}
                data={data}
                columns={columns}
                options={options}
            />
        );
    }
}

function convertDate(dateStr) {
    let date = new Date(dateStr);
    let year = date.getFullYear();
    let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    let day = date.getDate() + 1 < 10 ? '0' + (date.getDate() + 1) : date.getDate() + 1;
    let hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    let minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    let second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`
}
function mapStateToProps(state) {
    const { user } = state.authentication;
    const { projects } = state;

    return {
        user,
        projects
    };
}

export default connect(mapStateToProps)(DataTableContainer);


// WEBPACK FOOTER //
// ./src/components/AdminDashboard/Project/DataTableContainer.js